import BaseViz from './BaseViz'
import ChoroplethChart from '../charts/ChoroplethChart'
import ChoroplethDataController from '../viz_behaviors/ChoroplethDataController'
export default class ChoroplethViz extends BaseViz {
  static defaultConfig = {
    LegendBehavior:{
      showLegend: {
        value: true,
      },
      interactive: {
        nonEditable: true,
        exposed: false,
      },
    },
    TooltipBehavior:{
      getHasTooltip:function(d){
        return d[this.config.ItemsHelper.colorKey]!==null
      },
      getItemOffset:function ($el,d) {
        if(d.centroid){
          let parentRect = $el.closest('.chart-container').getBoundingClientRect()
          // console.log("this.paths",this.paths.default.projection)
          let path = this.paths[d.id] || this.paths.default
          let proj = path.projection()(d.centroid)
          return {
            x: proj[0] + parentRect.left,
            y: proj[1] + parentRect.top
          }
        }
        let targetRect = $el.getBoundingClientRect()
        return {
          x: targetRect.x + targetRect.width / 2,
          y: targetRect.y + targetRect.height / 2, //- 5,
        }
      },
    }
  }
  static chartClass = ChoroplethChart
  static dataControllerClass = ChoroplethDataController
}
